import RANK from '@/common/rank'
import firebase from 'firebase/app'
import firestore from '@/firebase/firestore'
import { FireSQL } from 'firesql'
import 'firesql/rx'
const aggregationRef = firestore.collection('aggregations')
const fireSQL = new FireSQL(firestore)
// let rankGraphDataSub$ = null
// let resultCountAllSub$ = null
let aggregations$ = null

const formatDate = function (date, format) {
  format = format.replace(/YYYY/, date.getFullYear())
  format = format.replace(/MM/, date.getMonth() + 1)
  format = format.replace(/DD/, date.getDate())
  format = format.replace(/HH/, date.getHours())
  format = format.replace(/II/, date.getMinutes())
  format = format.replace(/SS/, date.getSeconds())
  return format
}

const calcScore = function (clearQuestionCount, correctLetterCount, wrongLetterCount) {
  let score = clearQuestionCount * 500
  score += correctLetterCount * 10
  score -= wrongLetterCount * 5
  return Math.max(0, score)
}

const getRankByScore = function (score) {
  const rankData = RANK.RANK_DATA.find((rank) => {
    return rank.score <= score
  })
  return rankData
}

const mutations = {
  setResults (state, payload) {
    state.results = payload
  },
  setResult (state, result) {
    state.result = result
  },
  addToResults (state, result) {
    state.results.push(result)
  },
  setRankGraphData (state, data) {
    const sorted = data.sort(function (a, b) {
      var nameA = a.rank
      var nameB = b.rank
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    state.resultRankData = sorted
  },
  setTotalPlayCount (state, data) {
    state.totalPlayCount = data
  },
  setTotalTypeCount (state, data) {
    state.totalTypeCount = data
  }
}

const actions = {
  initResults ({ commit }) {
    commit('setResults', [])
  },
  subscribeAggregations ({ commit }) {
    if (process.env.NODE_ENV !== 'production') {
      return
    }
    if (aggregations$) {
      return
    }
    aggregations$ = fireSQL.rxQuery(`SELECT * FROM aggregations`)
    aggregations$.subscribe(results => {
      const result = results[0]
      const resultKeys = Object.keys(result)
      // トータルプレイ回数
      commit('setTotalPlayCount', result['total_play_count'])

      // ランクグラフ
      const rankData = []
      resultKeys.forEach((key) => {
        if (key.startsWith('rank_')) {
          const rankLetter = key.replace('rank_', '').replace('_count', '').toUpperCase()
          rankData.push({ rank: rankLetter, count: result[key] })
        }
      })
      commit('setRankGraphData', rankData)

      // トータルタイプ回数
      commit('setTotalTypeCount', result['total_type_count'])
    })
  },
  initialize ({ commit, dispatch }, { typeCount, wrongLetterData, clearQuestionCount, correctLetterCount }) {
    const keys = Object.keys(wrongLetterData)
    let wrongTypeCount = 0
    let maxLetterCount = 0
    let maxLetter = ''
    keys.forEach((key) => {
      wrongTypeCount += wrongLetterData[key]
      if (maxLetterCount < wrongLetterData[key]) {
        maxLetterCount = wrongLetterData[key]
        maxLetter = key
      }
    })

    const score = calcScore(clearQuestionCount, correctLetterCount, wrongTypeCount)
    const rank = getRankByScore(score)
    const wps = (correctLetterCount / 60).toFixed(1)
    const correctTypeRatio = (correctLetterCount / typeCount * 100).toFixed(2)
    const createdAt = formatDate(new Date(), 'YYYY-MM-DD HH:II:SS')
    const result = {
      score: score,
      typeCountAll: typeCount,
      typeCount: correctLetterCount,
      rank: rank.rankLetter,
      wrongTypeCount: wrongTypeCount,
      clearQuestionCount: clearQuestionCount,
      correctTypeRatio: correctTypeRatio,
      wordPerSecond: wps,
      wordPoorAt: maxLetter,
      createdAt: createdAt,
      value: 1
    }
    commit('setResult', result)
    dispatch('updateAggregation', result)
  },
  async updateAggregation ({ commit }, result) {
    const ref = aggregationRef.doc('7UZhtgqqOKYa9uN1fPPz')
    const aggregationDoc = await ref.get()
    const data = aggregationDoc.data()
    const updateParams = {}

    // ランク
    const rankLowerCase = result.rank.toLowerCase()
    updateParams[`rank_${rankLowerCase}_count`] = firebase.firestore.FieldValue.increment(1)

    // 最大クリア問題数
    if (data['max_cleared_question_count'] < result.clearQuestionCount) {
      updateParams[`max_cleared_question_count`] = result.clearQuestionCount
    }

    // 最大正解タイプ数
    if (data['max_correct_type_count'] < result.typeCount) {
      updateParams[`max_correct_type_count`] = result.typeCount
    }

    // 最大間違いタイプ数
    if (data['max_wrong_type_count'] < result.wrongTypeCount) {
      updateParams[`max_wrong_type_count`] = result.wrongTypeCount
    }

    // 最大スコア
    if (data['max_score'] < result.score) {
      updateParams[`max_score`] = result.score
    }

    // ミスタイプ
    updateParams[`poor_word_count_${result.wordPoorAt}`] = firebase.firestore.FieldValue.increment(1)

    // トータルタイプ数
    updateParams[`total_type_count`] = firebase.firestore.FieldValue.increment(result.typeCountAll)

    // トータル正解タイプ数
    updateParams[`total_correct_type_count`] = firebase.firestore.FieldValue.increment(result.typeCount)

    // トータル間違いタイプ数
    updateParams[`total_wrong_type_count`] = firebase.firestore.FieldValue.increment(result.wrongTypeCount)

    // トータルクリア問題数
    updateParams[`total_cleared_question_count`] = firebase.firestore.FieldValue.increment(result.clearQuestionCount)

    // トータルプレイ数
    updateParams[`total_play_count`] = firebase.firestore.FieldValue.increment(1)

    // トータルスコア数
    updateParams[`total_score`] = firebase.firestore.FieldValue.increment(result.score)
    ref.update(updateParams)
  },
  clear ({ commit }) {
    commit('init', [])
  },
  addResult ({ commit }, payload) {
    aggregationRef.add(payload)
      .then(doc => {
        // Do not mutate vuex store state outside mutation handlers.
      })
      .catch(err => {
        console.error('Error adding document: ', err)
      })
  }
}

const state = {
  result: {},
  results: [],
  resultRankData: [],
  totalPlayCount: 0,
  totalTypeCount: 0
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/result.js